import { handleActions } from 'redux-actions';

import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_ERROR,
  FETCH_NOTIFICATIONS_SUCCESS,
} from './actions';

const initialState = {
  isInitialized: false,
  isLoading: false,
  messages: [],
};

export default handleActions(
  {
    [FETCH_NOTIFICATIONS]: (state) => ({ ...state, isLoading: true }),
    [FETCH_NOTIFICATIONS_ERROR]: (state) => ({ ...state, isLoading: false }),
    [FETCH_NOTIFICATIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isInitialized: true,
      messages: [...payload], // TODO: implement
    }),
  },
  initialState
);
